module.exports = __webpack_public_path__ + "img/zw.c5a4202e.svg";